module.exports = __webpack_public_path__ + "static/media/beach2383.932fc2ca.jpg";